import React, { useEffect, useState } from "react";
import { getServices } from "../api";
import { FlipCard, SectionBadge } from "./services/FlipCard";

const slug = (s) => (s || "").toLowerCase().replace(/[^a-z0-9]+/g, "-");

const ProductShowcase = () => {
  const [services, setServices] = useState([]);
  const [group, setGroup] = useState(null);

  useEffect(() => {
    getServices()
      .then((data) => { setServices(data); setGroup(data[0]?.group || null); })
      .catch(() => setServices([]));
  }, []);

  const groups = [];
  services.forEach((s) => { if (!groups.includes(s.group)) groups.push(s.group); });
  const items = services.filter((s) => s.group === group);

  if (services.length === 0) return null;

  return (
    <section id="services" className="relative py-20 md:py-28 bg-[#F8FAFC] overflow-hidden" data-testid="services-section">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#06B6D4]/40 to-transparent" />
      <div className="pp-container">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <SectionBadge />
            <h2 className="mt-4 text-3xl md:text-5xl font-extrabold leading-[1.1] text-[#0D1B2A] max-w-3xl tracking-tight">
              Enabling Trusted Scalable Solutions. <span className="pp-grad-text">Seamless Integrations</span>
            </h2>
          </div>
          <p className="text-[#64748B] text-sm max-w-xs">Tap or hover any card to flip it and see what's inside.</p>
        </div>

        <div className="mt-10 -mx-4 px-4 overflow-x-auto pp-no-scrollbar">
          <div className="inline-flex gap-1 p-1.5 rounded-full bg-white border border-slate-200 shadow-sm" role="tablist">
            {groups.map((g) => {
              const on = g === group;
              const count = services.filter((s) => s.group === g).length;
              return (
                <button
                  key={g}
                  role="tab"
                  aria-selected={on}
                  onClick={() => setGroup(g)}
                  data-testid={`services-tab-${slug(g)}`}
                  className={`relative whitespace-nowrap px-5 py-2.5 rounded-full text-sm font-semibold transition-colors ${on ? "bg-[#0D1B2A] text-white" : "text-[#475569] hover:text-[#0D1B2A]"}`}
                >
                  {g}
                  <span className={`ml-2 text-[10px] px-1.5 py-0.5 rounded-full ${on ? "bg-[#06B6D4] text-[#030712]" : "bg-slate-100 text-[#64748B]"}`}>{count}</span>
                </button>
              );
            })}
          </div>
        </div>

        <div key={group} className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="services-grid">
          {items.map((s, i) => <FlipCard key={s.id} s={s} index={i} />)}
        </div>
      </div>
    </section>
  );
};

export default ProductShowcase;
